export const GET_AMEND_HUB_RECOMMENDATIONS_LOADING =
  'waitrose/orders/GET_AMEND_HUB_RECOMMENDATIONS_LOADING' as const;
export const GET_AMEND_HUB_RECOMMENDATIONS_LOADED =
  'waitrose/orders/GET_AMEND_HUB_RECOMMENDATIONSS_LOADED' as const;
export const GET_AMEND_HUB_RECOMMENDATIONS_FAILED =
  'waitrose/orders/GET_AMEND_HUB_RECOMMENDATIONS_FAILED' as const;

export const AMEND_HUB_EXPERIENCE_1 = 'order-amend-a';
export const AMEND_HUB_EXPERIENCE_2 = 'order-amend-b';
export const GET_AMEND_HUB_RECOMMENDATIONS = [
  GET_AMEND_HUB_RECOMMENDATIONS_LOADING,
  GET_AMEND_HUB_RECOMMENDATIONS_LOADED,
  GET_AMEND_HUB_RECOMMENDATIONS_FAILED,
] as const;
